module.exports = __webpack_public_path__ + "img/13_K_clubs.532fea43.png";